module.exports = __webpack_public_path__ + "img/uxImage.1f1aac44.png";